const parseJWT = (token) => {
  const base64Url = token.split(".")[1];
  const base64 = base64Url.replace("-", "+").replace("_", "/");
  return JSON.parse(window.atob(base64));
};
const validUntil = (token) => {
  const { exp } = parseJWT(token);
  return new Date(exp * 1e3);
};
const isValid = (token) => {
  const expireDate = validUntil(token);
  const now = /* @__PURE__ */ new Date();
  if (expireDate > now) {
    return true;
  }
  return false;
};
const getJWT = (name) => {
  const jwt = window.localStorage.getItem(name) || null;
  if (jwt && isValid(jwt)) {
    return jwt;
  }
  return null;
};
export {
  getJWT,
  isValid,
  parseJWT,
  validUntil
};
